import baseGetAllKeys from "./component-library338.mjs";
import getSymbolsIn from "./component-library339.mjs";
import keysIn from "./component-library340.mjs";
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}
export {
  getAllKeysIn as default
};
